module.exports = __webpack_public_path__ + "static/media/F2-Redux__Saga.230278c1.svg";